import { EntraIdRoleRequestDto } from 'api/kmsapiclient'
import { useTranslation } from 'react-i18next'

export type EntraIdRolesList = {
  entraIdRoles: EntraIdRoleRequestDto[]
}

export type EntraIdOperationRole = {
  name: string
  operationType: EntraIdOperationRoleType
  description: string
}

export enum EntraIdOperationRoleType {
  Key = 'Key',
  Permission = 'Permission',
  Administration = 'Administration',
  Secret = 'Secret',
}

export const EntraIdOperationRoles = () => {
  const { t } = useTranslation()

  return [
    {
      name: 'createKey',
      operationType: EntraIdOperationRoleType.Key,
      description: t('entraid.create_key'),
    },
    {
      name: 'rotateKey',
      operationType: EntraIdOperationRoleType.Key,
      description: t('entraid.rotate_key'),
    },
    {
      name: 'getKey',
      operationType: EntraIdOperationRoleType.Key,
      description: t('entraid.get_key'),
    },
    {
      name: 'deleteKey',
      operationType: EntraIdOperationRoleType.Key,
      description: t('entraid.delete_key'),
    },
    {
      name: 'addPermission',
      operationType: EntraIdOperationRoleType.Permission,
      description: t('entraid.add_permission'),
    },
    {
      name: 'updatePermission',
      operationType: EntraIdOperationRoleType.Permission,
      description: t('entraid.update_permission'),
    },
    {
      name: 'getPermission',
      operationType: EntraIdOperationRoleType.Permission,
      description: t('entraid.get_permission'),
    },
    {
      name: 'deletePermission',
      operationType: EntraIdOperationRoleType.Permission,
      description: t('entraid.delete_permission'),
    },
    {
      name: 'entraIDGroupRoles',
      operationType: EntraIdOperationRoleType.Administration,
      description: t('entraid.entraid_group_roles'),
    },
    {
      name: 'createSecret',
      operationType: EntraIdOperationRoleType.Secret,
      description: t('entraid.create_secret'),
    },
    {
      name: 'getSecret',
      operationType: EntraIdOperationRoleType.Secret,
      description: t('entraid.get_secret'),
    },
    {
      name: 'deleteSecret',
      operationType: EntraIdOperationRoleType.Secret,
      description: t('entraid.delete_secret'),
    },
  ]
}
